import React from "react";
import styled from "styled-components";

const BannerContainer = styled.div`
  top: 0;
  width: 100%;
  min-height: 30px;
  background-color: var(--background-green);
  display: flex;
  justify-content: center;
  align-items: center;

  p {
    margin: 0;
    padding-bottom: 2px;
    text-align: center;
    font-family: Georgia, sans-serif;
  }
`;

interface Props {
  id: string;
  text?: string;
}

const Banner: React.FC<Props> = ({ id, text }) => {
  return (
    <BannerContainer id={id}>
      <p> {text}</p>
    </BannerContainer>
  );
};

export default Banner;
